module.exports = __webpack_public_path__ + "media/newuservideobg.96c4d4dd.mp4";